export const getDataActive = ({ commit }, data) => {
  commit("SET_DATA_ACTIVE", data)
}
